export default {
  name: 'svgIcon',
  props: {
    data_iconName: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    svgClass: function svgClass() {
      //svg 的class
      if (this.className) {
        return "svg-icon ".concat(this.className);
      } else {
        return 'svg-icon';
      }
    },
    iconName: function iconName() {
      //svg xlink-href 指向的文件名
      return "#icon-".concat(this.data_iconName);
    }
  }
};